import { render, staticRenderFns } from "./RoleManageDrawer.vue?vue&type=template&id=22904f21&scoped=true"
import script from "./RoleManageDrawer.vue?vue&type=script&lang=js"
export * from "./RoleManageDrawer.vue?vue&type=script&lang=js"
import style0 from "./RoleManageDrawer.vue?vue&type=style&index=0&id=22904f21&prod&lang=scss&scoped=true"
import style1 from "./RoleManageDrawer.vue?vue&type=style&index=1&id=22904f21&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22904f21",
  null
  
)

export default component.exports